import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { CalendarEvent } from 'angular-calendar';
import { CustomersServices } from '../customers/services';
import { Globals } from '../../globals';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { startOfDay } from 'date-fns';
import { EmailServices } from '../services/emailServices';

//interface
interface Reservation {
  UID: string;
  UID_RESTAURANT: string;
  adults: number;
  children: number;
  date: string;
  delete: boolean;
  email: string;
  hour: string;
  message: string;
  name: string;
  phone: number;
  stripe: number;
  uid_client: string;
  customer_table: string
}

interface Reservation_complete {
  UID: string;
  UID_RESTAURANT: string;
  date: string;
  stripe: number;
  uid_reservation: string;
}

const colors: any = {
  manana: {
    primary: '#00B9CC',
    secondary: '#00B9CC'
  },
  mediodia: {
    primary: '#0071E2',
    secondary: '#0071E2'
  },
  noche: {
    primary: '#094D7C',
    secondary: '#094D7C'
  },
  full: {
    primary: '#ff0000',
    secondary: '#ff0000'
  },
  pending: {
    primary: '#F7B84B',
    secondary: '#F7B84B'
  },
  accepted: {
    primary: '#1ABC9C',
    secondary: '#1ABC9C'
  },
  in_table: {
    primary: '#3BAFDA',
    secondary: '#3BAFDA'
  },
  finished: {
    primary: '#323A46',
    secondary: '#323A46'
  },
  denied: {
    primary: '#F1556C',
    secondary: '#F1556C'
  },
  not_presented: {
    primary: '#6C757D',
    secondary: '#6C757D'
  },
  queue: {
    primary: '#6559CC',
    secondary: '#6559CC'
  },
  anulated: {
    primary: '#F1556C',
    secondary: '#F1556C'
  },
};



@Injectable()
export class ReservationsServices {

  public reservations_tmp: object;

  public firestore: any;
  reservationCol: AngularFirestoreCollection<Reservation>;
  reservations: Observable<Reservation[]>;
  reservationDoc: AngularFirestoreDocument<Reservation>;
  reservation: Observable<Reservation[]>;


  reservation_completeCol: AngularFirestoreCollection<Reservation_complete>;
  reservation_completes: Observable<Reservation_complete[]>;
  reservation_completeDoc: AngularFirestoreDocument<Reservation_complete>;
  reservation_complete: Observable<Reservation_complete[]>;
  reservations_complete: Observable<Reservation_complete[]>;
  //deleteStat: boolean = false;
  preparation: any = [];
  events$: Observable<Array<CalendarEvent<{ event: Event[] }>>>;
  events: any = [];

  //TMP - Son variables a utilizar en diferentes puntos de la creacio/edicion para enviar modificar la informacion de diferentes componentes
  public reservation_array_tmp: any = Array();
  public reservation_complete_array_tmp: any = Array();
  reservations_stripe_complete: any = Array();

  public stripe_1 = 0;
  public stripe_2 = 0;
  public stripe_3 = 0;

  public stripe_1_doc: any;
  public stripe_2_doc: any;
  public stripe_3_doc: any;

  public number_pendings = 0;

  public book_url: string = 'https://book.mycheftool.com/';
  public breakfast: boolean = true;
  public lunch: boolean = true;
  public dinner: boolean = true;
  public reservations_info: any = [];
  public reservations_pending: any = [];
  public reservations_info_by_day: any = [];
  public selected_date: any = new Date();
  public total_reservations_by_day: number = 0;
  public total_reservations_info_by_day: number = 0;

  constructor(public afs: AngularFirestore,
    public customersServices: CustomersServices,
    public globals: Globals,
    public datePipe: DatePipe,
    public translate: TranslateService,
    public emailServices: EmailServices) {
    this.firestore = firebase.firestore();

  }

  getListReservations(UID_RESTAURANT) {
    this.reservationCol = this.afs.collection('reservations', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('hour', 'asc'));
    this.reservations = this.reservationCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Reservation;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  getListReservationsComplete(UID_RESTAURANT, date) {
    this.reservation_completeCol = this.afs.collection('reservation_complete', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
    this.reservation_complete = this.reservation_completeCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Reservation_complete;
        data.UID = a.payload.doc.id;
        return data;
      });
    });

    this.reservation_complete.subscribe(docs => {
      docs.forEach(doc => {
        if (doc.date == date && doc.stripe == 1) {
          this.stripe_1 = 1;
          this.stripe_1_doc = doc;
        } else if (doc.date == date && doc.stripe == 2) {
          this.stripe_2 = 1;
          this.stripe_2_doc = doc;
        } else if (doc.date == date && doc.stripe == 3) {
          this.stripe_3 = 1;
          this.stripe_3_doc = doc;
        }
      });
    });
  }

  async getDayComplete(UID_RESTAURANT, date) {
    const ingredientsRef = this.firestore.collection('reservation_complete');

    var res_complete = [];

    await ingredientsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('date', '==', date)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var _complete = doc.data();
          _complete.UID = doc.id;

          res_complete.push(_complete);
        });
      });

    return res_complete
  }


  deleteReservation(uid) {
    this.afs.doc('reservations/' + uid).delete();
  }

  deleteStripeComplete(uid) {
    this.afs.doc('reservation_complete/' + uid).delete();
  }

  async getReservations(UID_RESTAURANT) {
    const reservationRef = this.firestore.collection('reservations');

    var reservations = [];

    await reservationRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var reservation = doc.data();
          reservation.UID = doc.id;

          reservations.push(reservation);
        })
      });

    return reservations
  }

  async getReservationsByState(UID_RESTAURANT, state) {
    const reservationRef = this.firestore.collection('reservations');

    var reservations = [];
    var number_reservations = 0;
    var date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    await reservationRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('state', '==', state)
      .where('date_order', '>=', new Date(date + 'T' + '00:00:00'))
      .orderBy('date_order', 'asc')
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var reservation = doc.data();
          reservation.UID = doc.id;
          number_reservations++;
          reservations.push(reservation);
        })
      });

    var _ret =
    {
      number_reservations: number_reservations,
      reservations: reservations,
    }

    return _ret
  }


  async getReservationsCanceled(UID_RESTAURANT) {
    const reservationRef = this.firestore.collection('reservations');

    var reservations = [];
    var number_reservations = 0;
    var date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    await reservationRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .where('date_order', '>=', new Date(date + 'T' + '00:00:00'))
      .orderBy('date_order', 'asc')
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var reservation = doc.data();
          reservation.UID = doc.id;
          if (reservation.state == 'denied' || reservation.state == 'anulated') {
            number_reservations++;
            reservations.push(reservation);
          }
        })
      });

    var _ret =
    {
      number_reservations: number_reservations,
      reservations: reservations,
    }

    return _ret
  }

  async checkInfoIFCustomerExists(email, phone) {
    var customers = await this.customersServices.getCustomers(this.globals.restaurant_uid);
    var _return = undefined;

    //check phone
    _phone = undefined;
    if (phone) {
      var _phone = customers.find(e => e.phone === phone);
      if (_phone) {
        _return = _phone;
      }
    }
    //check email
    _email = undefined;
    if (email) {
      var _email = customers.find(e => e.email === email);
      if (_email) {
        _return = _email;
      }
    }

    return _return;
  }


  async getReservation(uid) {

    const restRef = this.firestore.collection('reservations').doc(uid);

    var reservation;

    await restRef.get().then(doc => {
      reservation = doc.data();
      reservation.UID = doc.id;
    });

    return reservation

  }

  stripes = [];
  getReservationsEvents(reservations) {
    var preparation = [];
    var events = [];
    this.stripes = [];
    if (this.breakfast) {
      this.stripes.push(1);
    }
    if (this.lunch) {
      this.stripes.push(2);
    }
    if (this.dinner) {
      this.stripes.push(3);
    }
    var date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    var reservations_filter = this.globals.objectToArray(reservations).filter(x => this.stripes.indexOf(parseInt(x.stripe)) !== -1 /*&& x.state === 'accepted'*/);
    var _reservations_pending = this.globals.objectToArray(reservations).filter(x => x.state === 'pending' && x.date >= date); //Reservas pendientes a partir de hoy
    this.number_pendings = _reservations_pending.length;
    this.reservations_pending = [];
    _reservations_pending.forEach(reservation => {
      if (this.reservations_pending[reservation.date] == undefined) {
        this.reservations_pending[reservation.date] = [];
        this.reservations_pending[reservation.date].push(reservation);
      } else {
        this.reservations_pending[reservation.date].push(reservation);
      }
    });


    reservations_filter.forEach(doc => {
      if (doc.children == "") {
        doc.children = 0;
      }
      if (doc.delete) {
        doc.number = 0;
        doc.persons = 0;
      } else {
        doc.number = 1;
        doc.persons = parseInt(doc.adults) + parseInt(doc.children);
      }

      let color = 'colors.pending';
      if (doc.state == undefined) {
        doc.state = 'pending';
      }
      switch (doc.state) {
        case 'pending':
          color = 'pending';
          break;
        case 'accepted':
          color = 'accepted';
          break;
        case 'in_table':
          color = 'in_table';
          break;
        case 'finished':
          color = 'finished';
          break;
        case 'denied':
          color = 'denied';
          break;
        case 'not_presented':
          color = 'not_presented';
          break;
        case 'queue':
          color = 'queue';
          break;
        case 'anulated':
          color = 'anulated';
          break;
      }

      var stripe_name = '';
      if (doc.stripe == 1) {
        stripe_name = this.translate.instant('general-desayuno') + ' ';
      } else if (doc.stripe == 2) {
        stripe_name = this.translate.instant('general-almuerzo') + ' ';
      } else if (doc.stripe == 3) {
        stripe_name = this.translate.instant('general-cena') + ' ';
      }
      preparation[doc.date + '-' + doc.stripe + '-' + doc.UID] = {
        date: doc.date,
        stripe: doc.stripe,
        number: doc.number,
        persons: doc.persons,
        color: color,
        title: stripe_name,
        inserted: true,
      }
    });
    this.preparation = preparation;
    Object.keys(this.preparation).forEach(async key => {
      let value = this.preparation[key];
      events.push({
        start: startOfDay(value.date),
        title: value.title + ' ' + value.number + ' (' + value.persons + ')',
        color: this.returnColor(value),
        allDay: true,
        draggable: false
      });
    });
    events = events.sort((n1, n2) => {
      return this.naturalCompare(n1.title, n2.title)
    })
    this.events = events;
    return true;
  }

  getReservationsByDay() {
    this.reservations_info_by_day = this.reservations_info.filter(x => x.date === moment(this.selected_date).format('YYYY-MM-DD'));
    this.total_reservations_info_by_day = this.reservations_info.filter(x => x.date === moment(this.selected_date).format('YYYY-MM-DD') && x.state != 'denied' && x.state != 'anulated');
  }

  returnOrderDate(date, hour) {
    let dateString = date + 'T' + hour;
    return new Date(dateString);
  }

  async checkReservationsConfig() {
    //miramos si el restaurante tiene creada la subcollection reservations/config
    const restRef = this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config');
    const doc = await restRef.get();
    if (!doc.exists) {
      await this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').set({
        privacy_policy: '',
        bg_img: '',
      });
    }
  }

  async getReservationConfig() {
    const doc = await this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').get();
    return doc.data();
  }

  async createReservationsExample() {
    //Create customer
    //Pending
    this.createReservationPendingExample();
    //Accepted
    this.createReservationAcceptedExample();
    //Denied
    this.createReservationDeniedExample();
  }

  createReservationPendingExample() {
    var date = new Date(moment().format('YYYY-MM-DD'));
    //set time
    date.setHours(13);
    date.setMinutes(0);
    //Create reservation
    let reservation = {
      UID_CLIENT: '',
      UID_RESTAURANT: this.globals.restaurant_uid,
      UID_TABLE: '',
      adults: 2,
      children: 1,
      customer_table: '',
      date: moment().format('YYYY-MM-DD'),
      date_order: date,
      delete: false,
      email: this.globals.ifVarEmpty(this.globals.restaurant.email),
      hour: "13:00",
      message: "",
      name: "Nombre del cliente",
      phone: "634593229",
      state: "pending",
      stripe: "2",
      online: false,
      created_at: new Date(),
      updated_at: new Date()
    };
    //Pending
    this.firestore.collection('reservations').add(reservation);
    //Send email to restaurant New reservation pending
    this.emailServices.sendEmailReservation('new_reservation_pending', reservation);
    this.emailServices.sendEmailReservation('reservation_pending', reservation);
  }

  createReservationAcceptedExample() {
    var date = new Date(moment().format('YYYY-MM-DD'));
    //set time
    date.setHours(13);
    date.setMinutes(0);
    //Create reservation
    let reservation = {
      UID_CLIENT: '',
      UID_RESTAURANT: this.globals.restaurant_uid,
      UID_TABLE: '',
      adults: 2,
      children: 1,
      customer_table: '',
      date: moment().format('YYYY-MM-DD'),
      date_order: date,
      delete: false,
      email: this.globals.ifVarEmpty(this.globals.restaurant.email),
      hour: "13:00",
      message: "",
      name: "Nombre del cliente",
      phone: "634593229",
      state: "accepted",
      stripe: "2",
      online: false,
      created_at: new Date(),
      updated_at: new Date()
    };
    this.firestore.collection('reservations').add(reservation);
    //Send email to restaurant reservation accepted
    this.emailServices.sendEmailReservation('new_reservation_accepted', reservation);
    this.emailServices.sendEmailReservation('reservation_accepted', reservation);

  }

  createReservationDeniedExample() {
    var date = new Date(moment().format('YYYY-MM-DD'));
    //set time
    date.setHours(13);
    date.setMinutes(0);
    //Create reservation
    let reservation = {
      UID_CLIENT: '',
      UID_RESTAURANT: this.globals.restaurant_uid,
      UID_TABLE: '',
      adults: 2,
      children: 1,
      customer_table: '',
      date: moment().format('YYYY-MM-DD'),
      date_order: date,
      delete: true,
      email: this.globals.ifVarEmpty(this.globals.restaurant.email),
      hour: "13:00",
      message: "",
      name: "Nombre del cliente",
      phone: "634593229",
      state: "anulated",
      stripe: "2",
      online: false,
      created_at: new Date(),
      updated_at: new Date()
    };
    this.firestore.collection('reservations').add(reservation);
    //Send email to restaurant reservation denied
    reservation['reason'] = "";
    this.emailServices.sendEmailReservation('reservation_customer_denied', reservation);
    this.emailServices.sendEmailReservation('reservation_denied', reservation);
  }

  naturalCompare(a, b) {
    var ax = [], bx = [];

    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });

    while (ax.length && bx.length) {
      var an = ax.shift();
      var bn = bx.shift();
      var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
      if (nn) return nn;
    }

    return ax.length - bx.length;
  }

  returnColor(doc) {
    return colors[doc.color];
    /*var franja_completa = this.reservations_stripe_complete.find(e => e.date === this.datePipe.transform(doc.date, "yyyy-MM-dd") && parseInt(e.stripe) === parseInt(doc.stripe));

    if (franja_completa) {
      return colors.full;
    } else {
      if (doc.stripe == '1') {
        return colors.manana;
      } else if (doc.stripe == '2') {
        return colors.mediodia;
      } else if (doc.stripe == '3') {
        return colors.noche;
      }
    }*/
  }

}



// WEBPACK FOOTER //
// ./src/pages/reservation/services.ts